'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

const EnterResponovaPinBtn = () => {
  const pathname = usePathname()

  const nextUrl = {
    '/auth/login/activate-partner': '/auth/login/verify-pin?activate=1&pnir=1',
    '/auth/login/activate': '/auth/login/verify-pin?activate=1',
  }[pathname]

  return (
    <Link
      href={nextUrl as string}
      className='flex h-10 w-full items-center justify-center rounded-[36px] bg-primary-blue-700 text-sm font-medium text-white no-underline'
    >
      Enter Responova PIN
    </Link>
  )
}

export default EnterResponovaPinBtn
